export default {
  // imageBaseUrl: 'https://dbis-thure.uibk.ac.at/iiif/2',
  // imageBaseUrl: 'https://files-test.transkribus.eu/iiif/2',
  urls: {
    image: "https://files.transkribus.eu/iiif/2",
    xml: "https://files.transkribus.eu/Get?id=",
  },
  hashidsSecret: "1234",
  token: "",
  transcriptionURL: "https://transkribus.eu/r/testing/sandbox/application/",
  searchApiBaseUrl: "https://transkribus.eu/r/zQPlDb1ZvVWJuiBU/api/v0",
  apiBaseUrl: "https://transkribus.eu/TrpServerTesting/rest",
  contactEmail: "info@readcoop.eu",
  bugEmail: "bugs@readcoop.eu",
  bugtrackerUrl:
    "incoming+readcoop-webdev-public-transkribuslite-25175868-issue-@incoming.gitlab.com",
  repo: "https://gitlab.com/readcoop/webdev/public/transkribuslite",
  consentCookie: "cookieaccepted",
  recordSession: true,
};
